<!-- /****************************************************************************************************************
*  ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
<h3 mat-dialog-title>{{title}}</h3>
<div mat-dialog-content>
  <form [formGroup]="roleForm">
    <div class="wrap-break" style="margin:10px; display: flex; flex-direction: row; gap: 10px">
      <label style="align-self:center; flex: 0 0 10%; max-width: 10%; box-sizing: border-box"
      for="userRole.roles">{{'supplier.userlist.managerole.roles' | translate}}&nbsp;*</label>
      @if (roleCodes) {
        <ng-multiselect-dropdown style="min-width:89%" [settings]="dropdownSettingsForRoles"
          [data]="roleCodes" [(ngModel)]="userRole.roles" formControlName="roles">
        </ng-multiselect-dropdown>
      }
    </div>
    <div class="wrap-break" style="padding:10px; display: flex; flex-direction: row; gap: 10px">
      <label style="align-self:center; flex: 0 0 10%; max-width: 10%; box-sizing: border-box"
      for="userRole.apps">{{'supplier.userlist.managerole.apps' | translate}}&nbsp;*</label>
      @if (appList) {
        <ng-multiselect-dropdown style="min-width:89%" [settings]="dropdownSettingsForApps"
          [data]="appList" [(ngModel)]="userRole.apps" formControlName="apps" (onDeSelect)="onAppDeSelect($event)" (onDeSelectAll)="onAppDeSelectAll()">
        </ng-multiselect-dropdown>
      }
    </div>
    <div class="wrap-break" style="padding:10px; display: flex; flex-direction: row; gap: 10px">
      <div style="display: flex; flex-direction: column; flex: 1 1 30%; max-width: 30%; box-sizing: border-box">
        <mat-form-field>
          <mat-select panelClass="default-app-panel" style="font-size: 13px !important;" placeholder="Default App"
            formControlName="defaultApp" required>
            @for (app of userRole.apps; track app) {
              <mat-option [value]="app.id">
                {{app.itemName}}
              </mat-option>
            }
          </mat-select>
          @if (roleForm.controls.defaultApp.hasError('required') && (roleForm.controls.defaultApp.touched ||
            roleForm.controls.defaultApp.dirty)) {
            <mat-error>
              {{'supplier.userlist.managerole.defaultAppRequired' | translate}}
            </mat-error>
          }
        </mat-form-field>

      </div>
      <div style="display: flex; flex-direction: column; flex: 1 1 70%; max-width: 70%; box-sizing: border-box">
        <mat-form-field>
          <input matInput placeholder="{{'supplier.userlist.managerole.defaultPage' | translate}}"
            formControlName="defaultPage">

            @if (roleForm.controls.defaultPage.hasError('required') &&
              (roleForm.controls.defaultPage.touched ||
              roleForm.controls.defaultPage.dirty)) {
              <mat-error>
                {{'supplier.userlist.managerole.defaultPageRequired' | translate}}
              </mat-error>
            }
            @if (!roleForm.controls.defaultPage.hasError('required') && roleForm.controls.defaultPage.hasError('pattern') && (roleForm.controls.defaultApp.touched || roleForm.controls.defaultApp.dirty)) {
              <mat-error>
                {{'supplier.userlist.managerole.invalidDefaultPage' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button type="button" (click)="close()">
      {{'supplier.userlist.managerole.cancel' |translate }}
    </button>
    <button mat-raised-button cdkFocusInitial color="primary" type="submit" [disabled]="!roleForm.valid"
      (click)="updateRoles()">
      {{'supplier.userlist.managerole.submit' |translate }}
    </button>
  </div>
  <div>